// eslint-disable-next-line import/no-anonymous-default-export
export default {
  menu: {
    name: "ENCOO RPA Management Background",
    userManagement: {
      name: "User Management",
    },
    company: {
      name: "Company Management",
      enterprise: {
        name: "Enterprise Edition Users Management",
      },
      community: {
        name: "Community Edition Users Management",
      },
    },
    license: {
      name: "License",
      list: {
        name: "License Management",
      },
      studio: {
        name: "Studio License",
      },
      premiumRobot: {
        name: "PremiumRobot License",
      },
      localOCR: {
        name: "LocalOCR License",
      },
      console: {
        name: "Console License",
      },
    },
    installation: {
      name: "Installation Management",
    },
    aiManagement: {
      name: "AI Management",
      user: {
        name: "Account Management",
      },
      userService: {
        name: "Account Service Management",
      },
      service: {
        name: "AI Service Management",
      },
    },
  },
  info: {
    requestError: "Request Error",
  },
};
